<div class="committee">
  @if (loading()) {
    <section class="committee-card committee-card--state">
      <app-cog-loading-spinner [size]="56" />
      <p>Carregando o comitê de crédito...</p>
    </section>
  } @else if (error()) {
    <section class="committee-card committee-card--state" role="alert">
      <strong class="committee-error">{{ error() }}</strong>
      <app-button
        [label]="'Tentar de novo'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="load()" />
    </section>
  } @else if (view(); as v) {
    @if (round(); as r) {
      <!-- ══════════════ votação da rodada ══════════════ -->
      <section class="committee-card">
        <div class="committee-card__head">
          <div>
            <p class="committee-eyebrow">
              Comitê interno Legatus
              @if (r.round > 1) {
                · rodada {{ r.round }}
              }
            </p>
            <div class="committee-title-row">
              <h2 class="committee-title">Votação do deal</h2>
              @if (resultTag(r); as t) {
                <span class="committee-tag committee-tag--{{ t.tone }}">{{ t.label }}</span>
              }
            </div>
            @if (!isOpen() && r.decidedAt) {
              <p class="committee-result">
                Decidido em {{ r.decidedAt | vaultDateTime }} com
                {{ r.status === 'Denied' ? r.denials : r.approvals }} de
                {{ r.voters.length }} votos.
              </p>
            }
          </div>
          <p class="committee-muted">{{ quorum(r) }}</p>
        </div>

        @if (r.isHeldByContest && isOpen()) {
          <p class="committee-held" role="status">
            <i class="pi pi-pause-circle" aria-hidden="true"></i>
            <span>
              A maioria já se formou (<strong>{{ heldDirection(r) }}</strong
              >), mas há contestação em aberto. O comitê decide assim que o comercial responder.
            </span>
          </p>
        }

        <div class="voters">
          @for (voter of r.voters; track voter.userId) {
            @let b = badge(r, voter);
            @let sub = subtitle(r, voter);
            <div class="voter" [class.voter--me]="voter.isMe">
              <div class="voter__who">
                <span class="voter__avatar" aria-hidden="true">{{ initials(voter.name) }}</span>
                <div class="voter__texts">
                  <p class="voter__name">{{ voter.name }}</p>
                  <p class="voter__role">Sócio{{ voter.isMe ? ' · você' : '' }}</p>
                </div>
              </div>
              <span class="committee-tag committee-tag--{{ b.tone }}">{{ b.label }}</span>
              @if (sub.text) {
                <p class="voter__sub">
                  {{ sub.text }}
                  @if (sub.date) {
                    {{ sub.date | vaultDateTime }}
                  }
                </p>
              }
            </div>
          }
        </div>

        <div class="tally">
          <div class="tally__texts">
            <span>
              Aprovações <strong>{{ r.approvals }}</strong> · Negações
              <strong>{{ r.denials }}</strong> · {{ r.majority }} votos iguais decidem
            </span>
            <span>
              Contestações em aberto <strong>{{ r.openContestCount }}</strong>
            </span>
          </div>
          <div class="tally__track">
            <div
              class="tally__bar"
              role="img"
              [attr.aria-label]="
                r.approvals +
                ' aprovações e ' +
                r.denials +
                ' negações; ' +
                r.majority +
                ' votos iguais decidem'
              ">
              <span class="tally__approve" [style.width.%]="barWidth(r.approvals, r)"></span>
              <span class="tally__deny" [style.width.%]="barWidth(r.denials, r)"></span>
            </div>
            <span
              class="tally__mark"
              aria-hidden="true"
              [style.left.%]="majorityMark(r)"
              [title]="r.majority + ' votos iguais decidem'"></span>
          </div>
        </div>
      </section>

      <!-- ══════════════ discussão imutável ══════════════ -->
      <section class="committee-card">
        <div class="committee-card__head committee-card__head--center">
          <h2 class="committee-title">Discussão do comitê</h2>
          <span class="committee-lock">
            <i class="pi pi-lock" aria-hidden="true"></i>
            Registro imutável: nada se edita nem se apaga
          </span>
        </div>

        <ng-container *ngTemplateOutlet="entriesList; context: { $implicit: r }"></ng-container>

        <div class="composer">
          @if (!isOpen()) {
            <p class="committee-muted">
              Comitê encerrado em {{ r.decidedAt | vaultDateTime }}. A discussão fica registrada e
              não aceita novas entradas.
            </p>
          } @else {
            @switch (composer()) {
              @case ('voter') {
                @if (hasMyOpenContest()) {
                  <p class="committee-held committee-held--compact" role="status">
                    <i class="pi pi-pause-circle" aria-hidden="true"></i>
                    <span>
                      Sua contestação segura a decisão até o comercial responder. Você pode votar
                      agora ou contestar de novo.
                    </span>
                  </p>
                }
                <ng-container *ngTemplateOutlet="replyShortcut"></ng-container>
                <app-input
                  [type]="'textarea'"
                  [label]="'Seu voto e comentário'"
                  [placeholder]="'Obrigatório para Negar e Contestar. Opcional para Aprovar.'"
                  [textCenter]="false"
                  [maxLength]="textMaxLength"
                  [disabled]="sending() !== null || !v.canVote"
                  [ngModel]="draft()"
                  (ngModelChange)="onDraftChange($event)" />
                @if (draftError()) {
                  <p class="composer__error" role="alert">{{ draftError() }}</p>
                }
                <div class="composer__actions">
                  <app-button
                    [label]="'Aprovar'"
                    [icon]="'check'"
                    [theme]="'darkblue'"
                    [isLoading]="sending() === 'Approve'"
                    [loadingText]="'Enviando...'"
                    [disabled]="sending() !== null || !v.canVote"
                    [type]="'button'"
                    (sendButtonClick)="askFinalVote('Approve')" />
                  <span class="composer__contest">
                    <app-button
                      [label]="'Contestar'"
                      [icon]="'question-circle'"
                      [theme]="'outline-grey'"
                      [isLoading]="sending() === 'Contest'"
                      [loadingText]="'Enviando...'"
                      [disabled]="sending() !== null || !v.canVote"
                      [type]="'button'"
                      (sendButtonClick)="contest()" />
                  </span>
                  <app-button
                    [label]="'Negar'"
                    [icon]="'times'"
                    [theme]="'danger'"
                    [isLoading]="sending() === 'Deny'"
                    [loadingText]="'Enviando...'"
                    [disabled]="sending() !== null || !v.canVote"
                    [type]="'button'"
                    (sendButtonClick)="askFinalVote('Deny')" />
                  @if (v.canComment) {
                    <app-button
                      [label]="'Só comentar'"
                      [theme]="'link'"
                      [disabled]="sending() !== null"
                      [type]="'button'"
                      (sendButtonClick)="comment()" />
                  }
                </div>
                <p class="composer__hint">
                  Ao enviar, o registro fica gravado com autor, data e hora. Aprovar e Negar são
                  votos finais. Contestar manda a pergunta ao comercial, deixa seu voto em aberto e
                  segura a decisão do comitê até a resposta.
                </p>
                @if (!v.canVote) {
                  <p class="composer__hint">
                    Seu voto não pode ser registrado agora: falta a permissão de votar no comitê.
                    Peça a um administrador para incluí-la no seu grupo.
                  </p>
                }
              }
              @case ('voted') {
                <p class="composer__text">
                  Seu voto final foi registrado (<strong>{{
                    myVote() === 'Approve' ? 'Aprovar' : 'Negar'
                  }}</strong
                  >). Você ainda pode comentar até o comitê encerrar.
                </p>
                <ng-container *ngTemplateOutlet="replyShortcut"></ng-container>
                @if (v.canComment) {
                  <app-input
                    [type]="'textarea'"
                    [label]="'Comentário'"
                    [placeholder]="'Pergunta, observação ou complemento para os sócios'"
                    [textCenter]="false"
                    [maxLength]="textMaxLength"
                    [disabled]="sending() !== null"
                    [ngModel]="draft()"
                    (ngModelChange)="onDraftChange($event)" />
                  @if (draftError()) {
                    <p class="composer__error" role="alert">{{ draftError() }}</p>
                  }
                  <div class="composer__actions">
                    <app-button
                      [label]="'Comentar'"
                      [icon]="'comment'"
                      [theme]="'darkblue'"
                      [isLoading]="sending() === 'Comment'"
                      [loadingText]="'Enviando...'"
                      [disabled]="sending() !== null"
                      [type]="'button'"
                      (sendButtonClick)="comment()" />
                  </div>
                }
              }
              @case ('submitter') {
                @let contest = firstOpenContest();
                <app-input
                  [type]="'textarea'"
                  [label]="
                    contest
                      ? 'Responder à contestação de ' +
                        (contest.authorName || 'um sócio') +
                        ' (' +
                        entryNumber(contest.number) +
                        ')'
                      : 'Comentário do comercial'
                  "
                  [placeholder]="
                    contest
                      ? 'Responda ao que o sócio perguntou; anexe nos Documentos do deal o que ele pediu.'
                      : 'Comentário para os sócios'
                  "
                  [textCenter]="false"
                  [maxLength]="textMaxLength"
                  [disabled]="sending() !== null"
                  [ngModel]="draft()"
                  (ngModelChange)="onDraftChange($event)" />
                @if (draftError()) {
                  <p class="composer__error" role="alert">{{ draftError() }}</p>
                }
                <div class="composer__actions">
                  <app-button
                    [label]="contest ? 'Enviar resposta' : 'Comentar'"
                    [icon]="'send'"
                    [theme]="'darkblue'"
                    [isLoading]="sending() === 'Reply' || sending() === 'Comment'"
                    [loadingText]="'Enviando...'"
                    [disabled]="sending() !== null || (!contest && !v.canComment)"
                    [type]="'button'"
                    (sendButtonClick)="contest ? reply() : comment()" />
                  @if (myVoter()) {
                    <app-button
                      [label]="'Voltar ao voto'"
                      [theme]="'link'"
                      [disabled]="sending() !== null"
                      [type]="'button'"
                      (sendButtonClick)="setReplyMode(false)" />
                  } @else {
                    <span class="composer__hint composer__hint--inline">
                      O comercial não vota: responde às contestações e acompanha a decisão.
                    </span>
                  }
                </div>
              }
              @case ('comment') {
                <app-input
                  [type]="'textarea'"
                  [label]="'Comentário'"
                  [placeholder]="'Pergunta, observação ou complemento para os sócios'"
                  [textCenter]="false"
                  [maxLength]="textMaxLength"
                  [disabled]="sending() !== null"
                  [ngModel]="draft()"
                  (ngModelChange)="onDraftChange($event)" />
                @if (draftError()) {
                  <p class="composer__error" role="alert">{{ draftError() }}</p>
                }
                <div class="composer__actions">
                  <app-button
                    [label]="'Comentar'"
                    [icon]="'comment'"
                    [theme]="'darkblue'"
                    [isLoading]="sending() === 'Comment'"
                    [loadingText]="'Enviando...'"
                    [disabled]="sending() !== null"
                    [type]="'button'"
                    (sendButtonClick)="comment()" />
                </div>
              }
              @default {
                <p class="committee-muted">
                  Você acompanha este comitê. Votam os sócios da rodada; o comercial do deal
                  responde às contestações.
                </p>
              }
            }
          }
        </div>
      </section>
    } @else {
      <!-- ══════════════ sem rodada em votação ══════════════ -->
      <section class="committee-card">
        <p class="committee-eyebrow">Comitê de crédito</p>
        <h2 class="committee-title">
          {{
            previousRounds().length
              ? 'Este deal não tem rodada do comitê em votação'
              : 'Este deal ainda não foi enviado ao comitê'
          }}
        </h2>
        <p class="committee-text">
          Ao enviar, os sócios votantes recebem o pedido de voto no sino e por e-mail, com prazo de
          {{ v.deadlineHours }} horas.
        </p>
        @if (v.canSubmit) {
          <div class="committee-submit-row">
            <app-button
              [label]="'Enviar ao comitê'"
              [icon]="'send'"
              [theme]="'darkblue'"
              [type]="'button'"
              (sendButtonClick)="openSubmit()" />
            <span class="committee-muted">{{ configuredVotersText(v) }}</span>
          </div>
        } @else {
          <p class="committee-note">
            {{
              v.submitBlockedReason ||
                'Quem envia é o comercial do deal ou quem estiver na lista de quem envia, em Parametrização > Comitê de crédito do deal.'
            }}
          </p>
        }
      </section>
    }

    <!-- ══════════════ rodadas anteriores (recolhidas) ══════════════ -->
    @if (previousRounds().length) {
      <section class="committee-card">
        <h2 class="committee-title committee-title--small">Rodadas anteriores</h2>
        <ul class="rounds">
          @for (p of previousRounds(); track p.id) {
            <li class="rounds__item">
              <div class="rounds__head">
                <app-button
                  [label]="'Rodada ' + p.round"
                  [icon]="isExpanded(p.id) ? 'chevron-down' : 'chevron-right'"
                  [theme]="'link'"
                  [noMargin]="true"
                  [ariaLabel]="(isExpanded(p.id) ? 'Recolher' : 'Abrir') + ' a rodada ' + p.round"
                  [type]="'button'"
                  (sendButtonClick)="toggleRound(p.id)" />
                <span class="committee-tag committee-tag--{{ roundTone(p) }}">
                  {{ roundStatusLabels[p.status] }}
                </span>
                <span class="rounds__meta">
                  {{ p.approvals }} {{ p.approvals === 1 ? 'aprovação' : 'aprovações' }} ·
                  {{ p.denials }} {{ p.denials === 1 ? 'negação' : 'negações' }}
                  @if (p.decidedAt) {
                    · em {{ p.decidedAt | vaultDateTime }}
                  }
                </span>
              </div>
              @if (isExpanded(p.id)) {
                <ng-container
                  *ngTemplateOutlet="entriesList; context: { $implicit: p }"></ng-container>
              }
            </li>
          }
        </ul>
      </section>
    }
  }
</div>

<!-- Lista de entradas de uma rodada: a da votação atual e a de cada rodada anterior aberta. -->
<!-- Atalho de quem vota e também responde às contestações: linha própria, acima do campo. -->
<ng-template #replyShortcut>
  @if (canSwitchToReply()) {
    <div class="committee-held committee-held--compact" role="status">
      <i class="pi pi-comments" aria-hidden="true"></i>
      <span>{{ replyShortcutText() }}</span>
      <span class="committee-held__action">
        <app-button
          [label]="'Responder ' + entryNumber(firstOpenContest()!.number)"
          [icon]="'reply'"
          [theme]="'link'"
          [disabled]="sending() !== null"
          [type]="'button'"
          (sendButtonClick)="setReplyMode(true)" />
      </span>
    </div>
  }
</ng-template>

<ng-template #entriesList let-r>
  <ol class="entries">
    @for (entry of r.entries; track entry.id) {
      @let t = tag(entry, r);
      <li
        class="entry"
        [class.entry--reply]="entry.kind === 'Reply'"
        [class.entry--system]="entry.kind === 'System'">
        <div class="entry__head">
          <div class="entry__who">
            <span class="entry__author">{{ author(entry) }}</span>
            @if (roleLabel(entry)) {
              <span class="entry__role">{{ roleLabel(entry) }}</span>
            }
            <span class="committee-tag committee-tag--{{ t.tone }}">{{ t.label }}</span>
            @if (reference(entry)) {
              <span class="entry__role">{{ reference(entry) }}</span>
            }
          </div>
          <span class="entry__when">
            {{ entryNumber(entry.number) }} · {{ entry.occurredAt | vaultDateTime }}
          </span>
        </div>
        <p class="entry__text">{{ entry.text }}</p>
      </li>
    } @empty {
      <li class="committee-muted">Nenhum registro nesta rodada.</li>
    }
  </ol>
</ng-template>

<app-modal-committee-submit
  #submitModal
  [dialogKey]="'committee-submit-panel'"
  (submitted)="onSubmitted($event)" />
<app-modal-committee-vote #voteModal (confirmed)="sendVote($event)" />
